// TermsAndConditions.js
import React from "react";
import "./tearm&conditions.css";
import Header from "../../components/Navbar";
import Footer from "../../components/footer/footer"

function TermsAndConditions() {
  return (
    <>
    <Header />
   <div className="max-w-5xl mx-auto p-6 text-gray-800 leading-relaxed">
      {/* Title */}
      <h1 className="text-2xl font-bold text-center mb-2">
        TERMS AND CONDITIONS
      </h1>
      <p className="text-center text-gray-600 mb-6">
        Effective: September 03, 2025
      </p>

      <div className="h-[75vh] overflow-y-auto pr-4 space-y-4">
        <p>
          These Terms & Conditions (the “Agreement”) are a legal agreement
          between you and Twoffers (“Twoffers,” “we,” “us,” or “our”). By
          accessing or using the Twoffers website [https://www.twoffers.com] (the
          “Site”) and any related services, tools, or mobile applications
          (collectively, the “Platform”), including any affiliated websites or
          applications we operate (the “Affiliated Websites and Apps”), you agree
          to be bound by this Agreement.
        </p>

        <p>
          Important: This Agreement includes a class action waiver, warranty
          disclaimers, limitations of liability, and your agreement to indemnify
          Twoffers. Section 16 explains consent to be contacted (and how to revoke
          it).
        </p>

        <p>
          We may update this Agreement from time to time. We’ll post changes on
          the Site (and/or notify you by email where required). If you disagree
          with the changes, stop using the Platform. Your continued use
          constitutes acceptance of the updated Terms. You are responsible for
          reviewing updates posted on the Site.
        </p>

        <p>
          This Agreement applies to all properties, listings, or assets marketed
          for sale or offer through the Platform, whether via time-limited
          Listings or offer-based formats.
        </p>

        <p>
          Selected bidders (“Selected Bidders”) must execute a purchase and sale
          agreement or similar contract with the seller (each, a “Purchase
          Agreement”). The Purchase Agreement governs the sale terms between the
          seller (the “Seller”) and the buyer (the “Buyer”); Twoffers is not a
          party to the Purchase Agreement. If there is a conflict between this
          Agreement and the Purchase Agreement, the Purchase Agreement controls
          for the parties bound to it.
        </p>

        <p>
          Any use of the Platform by a licensed agent or auctioneer is also
          governed by this Agreement and (if applicable) the additional terms in
          Section 12.
        </p>

        {/* Defined Terms */}
        <h2 className="text-lg font-semibold mt-6">DEFINED TERMS</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <b>“Affiliated Websites and Apps”</b> — has the meaning given above.
          </li>
          <li>
            <b>“Auction Marketing”</b> — an online format in which the Seller
            considers bids for a fixed period (time-limited auction).
          </li>
          <li>
            <b>“Back-Up Bid”</b> — a bid submitted during an Auction Marketing
            that is not the Selected Bid but is kept available to the Seller for
            a period chosen by the Seller. The Seller may accept a Back-Up Bid at
            its sole discretion; there is no guarantee it will be selected.
          </li>
          <li>
            <b>“Bid Deposit”</b> — a hold placed on a bidder’s payment method
            before bidding on certain listings. This may convert to a
            non-refundable charge if a Selected Bidder fails to perform (see
            Section 1(e)).
          </li>
          <li>
            <b>“Bidder”</b> — a person or entity that places a bid or offer on a
            listing.
          </li>
          <li>
            <b>“Buyer”</b> — a person or entity that enters into a binding
            Purchase Agreement with the Seller.
          </li>
          <li>
            <b>“Buyer’s Premium”</b> — a fee charged to Buyers for purchases made
            via Auction Marketing (disclosed on the listing page, if applicable).
          </li>
          <li>
            <b>“Earnest Money Deposit”</b> — a good-faith deposit paid to the
            escrow agent under the Purchase Agreement.
          </li>
          <li>
            <b>“Listing Page”</b> — the property or asset details page (features,
            photos, fees, disclosures, etc.).
          </li>
          <li>
            <b>“No-Time-Limit Marketing”</b> — an offer-based process without a
            specific time limit for submitting offers.
          </li>
          <li>
            <b>“Property/Asset Bid Page”</b> — the page where placing a bid/hold
            is configured and related fees are shown.
          </li>
          <li>
            <b>“Reserve Price”</b> — the Seller’s minimum price for auctioned
            items (may or may not be disclosed).
          </li>
          <li>
            <b>“Selected Bid”</b> — (a) for Auction Marketing: the bid the Seller
            selects in its discretion after the auction ends; (b) for
            No-Time-Limit Marketing: an offer tentatively approved by the Seller.
            A Selected Bid does not guarantee a sale; the Seller may still decline
            to sign the Purchase Agreement.
          </li>
          <li>
            <b>“Selected Bidder”</b> — the bidder who placed the Selected Bid.
          </li>
          <li>
            <b>“Seller”</b> — the owner of, or authorized party for, a listed
            property or asset on the Platform.
          </li>
          <li>
            <b>“Starting Bid”</b> — the nominal opening bid shown when an auction
            begins (may be below the Reserve Price).
          </li>
          <li>
            <b>“Technology/Platform Fee”</b> — a fee charged on certain
            transactions (disclosed on the Listing Page, if applicable).
          </li>
        </ul>

        {/* Section 1 onwards */}
        <h2 className="text-lg font-semibold mt-6">1) Services; Fees</h2>
        <p>
          (a) <b>Limited License</b> — Subject to this Agreement, Twoffers grants
          you a limited, revocable, non-exclusive, non-transferable,
          non-sublicensable license to access and use the Platform...
        </p>
<div className="max-w-4xl mx-auto p-6 text-gray-800 leading-relaxed">
      {/* Section (b) Proprietary Rights */}
      <h2 className="text-xl font-semibold mt-6">(b) Proprietary Rights</h2>
      <p className="mt-2">
        The Platform, including its selection, arrangement, software, and
        content, is owned by or licensed to Twoffers and protected by
        intellectual property laws. Except for the license above, all rights are
        reserved. Do not remove or obscure proprietary notices.
      </p>

      {/* Section (c) Third-Party & User Content */}
      <h2 className="text-xl font-semibold mt-6">(c) Third-Party & User Content</h2>
      <p className="mt-2">
        Some content is supplied by Sellers, agents, and other users. We do not
        control or endorse third-party content and are not responsible for its
        accuracy or reliability.
      </p>

      {/* Section (d) Use & Storage */}
      <h2 className="text-xl font-semibold mt-6">(d) Use & Storage</h2>
      <p className="mt-2">
        We may set general practices and limits (e.g., data retention, access
        frequency).
      </p>

      {/* Section (e) Bidder Requirements & Fees */}
      <h2 className="text-xl font-semibold mt-6">(e) Bidder Requirements & Fees</h2>
      <p className="mt-2">
        You must register an account to submit bids or offers. Activation may
        take up to 24 hours; you cannot bid/offer until activated.
      </p>
      <p className="mt-2">Fees and holds may apply:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>(i) Bid Deposit & Funds Verification:</strong> Authorization
          holds and verification charges apply. Non-selected bidders usually get
          releases within 5–10 business days unless opting for Back-Up Bid. If
          selected, hold remains until conditions are met.
        </li>
        <li>
          <strong>(ii) Earnest Money Deposit:</strong> A percentage of your bid
          must be deposited in escrow within required timeframe.
        </li>
        <li>
          <strong>(iii) Technology/Platform Fee:</strong> May apply in certain
          transactions, disclosed on the Listing Page.
        </li>
        <li>
          <strong>(iv) Buyer’s Premium:</strong> May apply in Auction Marketing,
          typically calculated on the Selected Bid.
        </li>
      </ul>

      {/* Section 2 */}
      <h2 className="text-xl font-semibold mt-8">2) Eligibility & Your Responsibilities</h2>
      <p className="mt-2">
        (a) Who May Use Twoffers – Must be legally capable of forming a binding
        contract.  
        (b) Registration – Provide true and updated details.  
        (c) Identity & Security – Responsibility for credentials is yours.  
        (d) Prohibited Activities – No unlawful, misleading, harmful, or spam
        content.  
        (e) No Shill Bidding / No Scams – Strictly prohibited.  
        (f) Reverse Engineering; Automated Access – Prohibited.  
        (g) Bulk Downloads – Excessive retrieval not allowed.  
        (h) Access & Interference – Cannot overload infrastructure.  
        (i) Termination – Accounts can be suspended/terminated at our
        discretion.
      </p>

      {/* Section 3 */}
      <h2 className="text-xl font-semibold mt-8">3) Twoffers Is a Platform</h2>
      <p className="mt-2">
        Twoffers is not an auctioneer or broker. We provide a technology
        platform for Sellers and Buyers. We don’t control listing accuracy or
        ability to close.
      </p>
      <ul className="list-disc pl-6 mt-2 space-y-2">
        <li>
          <strong>Release:</strong> Disputes are between users; Twoffers is not
          liable.
        </li>
        <li>
          <strong>Information Control:</strong> Content may be inaccurate or
          offensive.
        </li>
        <li>
          <strong>Service Interruptions:</strong> Platform may be unavailable at
          times; events may be extended or re-run.
        </li>
      </ul>

      {/* Section 4 */}
      <h2 className="text-xl font-semibold mt-8">4) Bidding & Buying</h2>
      <p className="mt-2">
        (a) Intent to Purchase – Bidding indicates intent but doesn’t bind
        Seller until agreement is signed.  
        (b) Failure to Complete – Bid Deposit may be forfeited.  
        (c) Anti-Sniping Extensions – Listings may auto-extend.  
        (d) Notifications – Delivery not guaranteed; check Platform.  
        (e) Seller Discretion – Seller may accept/reject bids.  
        (f) Pre-Qualification / Proof of Funds – May be requested.  
        (g) Competing / Reserve Bids – May occur where legal.
      </p>

      {/* Section 5 */}
      <h2 className="text-xl font-semibold mt-8">5) Listing Condition; No Warranties</h2>
      <p className="mt-2">
        (a) “As-Is” Condition – Listings offered as-is.  
        (b) No Warranties – Platform is “as-is” and “as available.” All implied
        warranties disclaimed.
      </p>

      {/* Section 6 */}
      <h2 className="text-xl font-semibold mt-8">6) Privacy</h2>
      <p className="mt-2">See our Privacy Policy at [link to Twoffers Privacy Policy].</p>

      {/* Section 7 */}
      <h2 className="text-xl font-semibold mt-8">7) Indemnity</h2>
      <p className="mt-2">
        You agree to defend, indemnify, and hold harmless Twoffers and its
        affiliates against claims, damages, and liabilities.
      </p>

      {/* Section 8 */}
      <h2 className="text-xl font-semibold mt-8">8) Limitation of Liability</h2>
      <p className="mt-2">
        To the maximum extent permitted by law, liability is limited to $100 (or
        local equivalent). No indirect or consequential damages covered.
      </p>

      {/* Section 9–17 */}
      <h2 className="text-xl font-semibold mt-8">9) Legal Compliance</h2>
      <p className="mt-2">You must comply with applicable laws and regulations.</p>

      <h2 className="text-xl font-semibold mt-6">10) No Agency</h2>
      <h2 className="text-xl font-semibold mt-6">11) General</h2>
      <h2 className="text-xl font-semibold mt-6">12) Additional Terms for Licensed Agents</h2>
      <h2 className="text-xl font-semibold mt-6">13) Jurisdiction-Specific Auction Terms</h2>
      <h2 className="text-xl font-semibold mt-6">14) Loan/Note Sales</h2>
      <h2 className="text-xl font-semibold mt-6">15) Commercial Listings — Confidentiality</h2>
      <h2 className="text-xl font-semibold mt-6">16) Communication Consent</h2>
      <h2 className="text-xl font-semibold mt-6">16.1 SMS Messages</h2>
      <h2 className="text-xl font-semibold mt-6">17) Contact Us</h2>
      <p className="mt-2">
        Twoffers  
        [Company Legal Name]  
        [Address]  
        [Support Email] • [Support Phone]
      </p>
    </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default TermsAndConditions;
